export const FAILURE_REASON_OPTIONS = [
  { label: "Client refused", value: "refused" },
  { label: "Client unaware or misinformed", value: "clientUnaware" },
  { label: "Client unavailable", value: "unavailable" },
  { label: "Logistical issues", value: "logisticsProcess" },
  { label: "Property challenges", value: "propertyChallenges" },
  { label: "Technical issues", value: "technicalIssue" },
  { label: "Unsafe", value: "unsafe" },
  { label: "Other", value: "other" },
] as const;

export type FailureReason = (typeof FAILURE_REASON_OPTIONS)[number]["value"];

export const getHumanReadableFailReason = (failReason: FailureReason): string => {
  const match = FAILURE_REASON_OPTIONS.find(
    (option) => option.value === failReason
  );
  return match?.label || failReason;
};
